module.exports = " <div class=Content> <app-leftcolumn> <left-menu></left-menu> </app-leftcolumn> <div class=bloc-center-row> <app-centercolumn> <router-view></router-view> </app-centercolumn> <app-widgetcentercolumn> <preview></preview> </app-widgetcentercolumn> </div> <app-rightcolumn> <widget-calendar></widget-calendar> <meeting-view></meeting-view> <preview></preview> </app-rightcolumn> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/views/ContactView.vue
// module id = 523
// module chunks = 1